import {Column} from './column';

export class Table {

    name:string;
    columns:Column[] = [];
    alterTable = false;

    constructor(json:any) {
         this.name = json.name;

         if(json.columns!=null) {
             for (let i = 0; i < json.columns.length; i++) {
                 this.columns.push(new Column(json.columns[i].name, json.columns[i].type));
             }
         }
    }

    public getColumnIndex(colName:string):number {
        const tmp = this.columns.values();

         let indx = -1;
        while(true) {
            indx++;
            const val = tmp.next();
            if(val.value.name === colName) {
                break;
            }
        }

        return indx;
    }


}
